import React from 'react';
import { TextInput, CheckBox } from 'hyperdb-utils';

const ChannelTab = ({ objectData, channels = [], onChange, units = [], forNew = false }) => {
  const settings = objectData.source_channel_settings || {};
  const selectedChannel = settings.channel_id ? channels.find(c => c.id === settings.channel_id.value[1]) : null;
  let checkboxesToDisplay = [];
  if (selectedChannel) {
    switch (selectedChannel.protocol) {
    case 'SPRAB':
      checkboxesToDisplay = ['receive_prices', 'receive_conditions', 'receive_availability', 'send_reservations'];
      break;
    case 'ICAL':
      checkboxesToDisplay = ['receive_availability'];
      break;
    case 'Domino':
    default:
      checkboxesToDisplay = ['receive_property_details', 'receive_prices', 'receive_conditions', 'receive_availability', 'send_inquiries', 'send_reservations'];
    }
  }
  const handleClickSettingsCheckbox = (attributeName) => {
    settings[attributeName] = !settings[attributeName];
    onChange('source_channel_settings', { value: settings });
  };
  const handleChangeUnitRemoteId = (index, field) => {
    const _units = units.slice();
    _units[index].remote_id = field.value;
    onChange('units', { value: _units });
  };

  return (
    <div>
      {
        !forNew && selectedChannel
          ? <h4>Channel { selectedChannel.name }</h4>
          : null
      }
      {
        selectedChannel && ['Domino', 'SPRAB'].includes(selectedChannel.protocol)
          ? <TextInput
              label="Remote id"
              name="remote_id"
              value={ objectData.remote_id }
              onChange={ onChange.bind(null, 'remote_id') }
            />
          : null
      }
      {
        selectedChannel
          ? <div>
              {
                ['receive_property_details', 'receive_prices', 'receive_conditions', 'receive_availability', 'send_inquiries', 'send_reservations']
                  .map((checkbox, i) => {
                    const disabled = !checkboxesToDisplay.includes(checkbox);
                    return (
                      <CheckBox
                        key={ i }
                        label={ checkbox.replace(/_/g, ' ') }
                        name={ checkbox }
                        checked={ settings[checkbox] }
                        disabled={ disabled }
                        onChange={ handleClickSettingsCheckbox.bind(null, checkbox) }
                      />
                    );
                  })
              }
            </div>
          : null
      }
      {
        !forNew
          ? <fieldset>
              <legend>Units</legend>
              <table className="table table-hover table-striped table-bordered table-responsive">
                <thead>
                  <tr>
                    <th>number</th>
                    <th>remote_id</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    units.map((unit, i) => {
                      return (
                        <tr key={ i }>
                          <td>
                            {unit.number || i}
                          </td>
                          <td>
                            <TextInput
                              label={ null }
                              value={ unit.remote_id }
                              onChange={ handleChangeUnitRemoteId.bind(null, i) }
                            />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </fieldset>
          : null
      }
    </div>
  );
};

export default ChannelTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/ChannelTab.jsx